import { PIcon } from "@porsche-design-system/components-react"
import { CopyToClipboard } from "./CopyToClipboard"
import type { CopyToClipboardProps } from "./CopyToClipboard"

export const CopyToClipboardInsideTag = (props: Omit<CopyToClipboardProps, "compact">) => (
	<>
		<CopyToClipboard {...props} as="button" compact />
		<PIcon name="copy" color="inherit" size="2xs" />
	</>
)
